import { FormBuilder, FormGroup } from "@angular/forms";
import { invoice } from "./organisationModels";

export class falUserModel {
  email: string;
  fullName: string;
  createdDate: Date;
  id: string;
  region: string;
  language: string;
  lastLogin: Date;
  locked: boolean;
  mobileNumber: string;
  organisations: userOrgModel[] = [];
  serviceDescriptor: string;
  accountVerified = false;
  systemAdmin: boolean;
  betaTester: boolean;
  ssoLogin: boolean;
  ssoProvider: string;
  ssoUuid: string;
}

export class userOrgModel {
  id: number;
  orgId: string;
  organisationName: string;
  permissionAddPayment: boolean;
  permissionAddService: boolean;
  permissionAddUser: boolean;
  permissionAmendService: boolean;
  permissionCancelService: boolean;
  permissionDeleteUser: boolean;
  permissionMakePayment: boolean;
  permissionModifyUser: boolean;
  permissionRemovePayment: boolean;
  permissionUpdatePassword: boolean;
  services: orgServiceModel[] = [];

  get canManageUsers(){
    return this.permissionAddUser && this.permissionModifyUser && this.permissionDeleteUser && this.permissionUpdatePassword;
  }

  get canManageSubs(){
    return this.permissionAddService && this.permissionAmendService && this.permissionCancelService;
  }

  get canManagePayments(){
    return this.permissionAddPayment && this.permissionMakePayment && this.permissionRemovePayment;
  }
}

export class orgServiceModel {
  id: number;
  available: boolean;
  serviceName: string;
  serviceKey: string;
  serviceUnit: string;
  unitQuantity: number;
  suspended: boolean;
  suspendedReason: string;
  terminated: boolean;
  terminationReason: string;
  currentUsage: number;
  billingOrganisationName: string;
  billingOrganisationId: string;
  validPaymentMethod: boolean;
  freeTrialActive: boolean;
  billingStartDate: Date;
  createdDate: Date;
  nextBillingDate: Date;
  billingPeriod: string;
  hasPendingChanges: boolean;
  pendingChange: PendingChangeModel;
  lastInvoiceNumber: number;
  paymentState: string;
  features: ServiceFeatureModel[];
  cardExpiring: boolean;
  suspensionDetails: SuspensionDetailsModel;
}

export class SuspensionDetailsModel{
    currentInvoice: invoice;
    lastInvoice: invoice;
}

export class serviceUsageModel {
  id: number;
  usage: number;
}

export class ServiceFeatureModel {
  quantity: number;
  blockQuantity: number;
  featureKey: string;
  featureName: string;
  featureDescripion: string;
  cost: number;
  usage: number;
}

export class PendingChangeModel {
    id: number;
  createdOn: Date;
  completedOn: Date;
  invoiceId: number;
  changeType: string;
  proposedChange: string;
  status: string;
  responseMessage: string;
}

export class createUserModel {
  email: string;
  password: string;
  fullName: string;
  mobileNumber: string;
  region: string;
  language: string;
  ssoProvider: string;
  ssoUuid: string;
}

export class updateUserModel extends createUserModel {
  safeId: string;
}


export class userLoginAudit {
  timestamp: Date;
  userName: string;
  purpose: string;
  result: string;
}

export class orgUserRole {
  id: number;
  userId: number;
  organisationId: number;
  organisationSafeId: string;
  permissionAddService: boolean;
  permissionAdmendService: boolean;
  permissionCancelService: boolean;
  permissionAddPayment: boolean;
  permissionRemovePayment: boolean;
  permissionMakePayment: boolean;
  permissionAddUser: boolean;
  permissionModifyUser: boolean;
  permissionDeleteUser: boolean;
  permissionUpdatePassword: boolean;
  suspended: boolean;

  static createPermissionForm(fb: FormBuilder, our: orgUserRole): FormGroup {
    if (our === null) {
      our = new orgUserRole();
    }
    return fb.group({
      permissionAddService: our.permissionAddService,
      permissionAmendService: our.permissionAdmendService,
      permissionCancelService: our.permissionCancelService,
      permissionAddPayment: our.permissionAddPayment,
      permissionRemovePayment: our.permissionRemovePayment,
      permissionMakePayment: our.permissionMakePayment,
      permissionAddUser: our.permissionAddUser,
      permissionModifyUser: our.permissionModifyUser,
      permissionDeleteUser: our.permissionDeleteUser,
      permissionUpdatePassword: our.permissionUpdatePassword
    });
  }
}

export class ResourceChangeRequestDetailItem {
  featureKey: string;
  featureName: string;
  quantity: number;
  cost: number;
}

export class ResourceChangeRequestDetail {
  items: ResourceChangeRequestDetailItem[];
  priceDifference: number;
}

export class FreeTrialEndRequestDetail extends ResourceChangeRequestDetail {
  billingPeriod: string;
  billingStartDate: Date = new Date();
}
